module.exports = __webpack_public_path__ + "img/ergLogo3@2x.3091cdb9.jpg";